import { Text } from "rizzui/typography";
import EditIcon from "../../assets/edit";
import { ActionIcon } from "rizzui/action-icon";
import React from "react";
export default function ConnectionNotSuccesful({
  onEdit,
}: {
  onEdit?: React.Dispatch<React.SetStateAction<string>>;
}) {
  return (
    <div className="border-[0.5px] border-muted p-[32px] rounded-[8px] w-full flex-1">
      <div className="flex flex-col gap-[32px]">
        <div className="flex flex-col gap-[8px] text-center">
          <Text className="font-ibmPlexSerif font-[600] text-[18px] text-primary-dark">
            Connection not successful
          </Text>
          <Text className="text-[#758599] font-switzer text-[14px] font-[400] w-[223px] mx-auto">
            There is an error in your configuration
          </Text>
        </div>

        <div className="bg-[#F5F9FF] dark:bg-muted p-[16px] rounded-[8px] border border-muted w-full">
          <div className="flex flex-col gap-[8px]">
            <Text className="text-primary-dark font-[400] font-switzer text-[12px]">
              Authentication verified
            </Text>
          </div>
        </div>

        <div className="bg-[#F044381A] dark:bg-[#FE00001A] h-[32px] px-[16px] rounded-[8px] border border-[#E63946] dark:border-[#FF3E4D] w-full">
          <div className="flex justify-between gap-[8px] items-center">
            <Text
              className="font-[400] font-switzer text-[12px] text-[#E63946] dark:text-[#FF3E4D]
"
            >
              Data mapping not well configured
            </Text>

            <ActionIcon
              className="!bg-transparent !w-fit !h-fit flex gap-[8px] text-[#E63946] dark:text-[#FF3E4D] items-center cursor-pointer"
              onClick={() => onEdit && onEdit("data-mapping")}
            >
              <EditIcon className={"text-[#E63946]"} />
              <Text className="font-switzer text-[12px] font-[500]">Edit</Text>
            </ActionIcon>
          </div>
        </div>
      </div>
    </div>
  );
}
